import useFetch from 'elements/Hooks/useFetch'
import CustomTable from 'elements/Table/CustomTable'
import React from 'react'
import { Link } from 'react-router-dom'

export default function RFQListByEnquiryLines({ id }) {
  const { data, fetching, fetch } = useFetch({ url: `/enquiries/lines/${id}/rfq` })


  const columns = [
    {
      Header: 'ID',
      accessor: '_id',
      width: 200,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'RFQ',
      accessor: 'code',
      width: 150,
      Cell: ({ original, value }) => (
        <Link
          target={'_blank'}
          to={{
            pathname: `purchasing/rfq/${original._key}/update`,
          }}>
          {value}
        </Link>
      ),
    },
    {
      Header: 'Vendor',
      accessor: 'vendor.fn',
      width: 150,
    },
    {
      Header: 'Status',
      accessor: 'status',
      width: 150,
    },
    {
      Header: 'Issued',
      accessor: 'issuance.issued',
      width: 150,
      Cell: ({ value }) => (value ? 'Issued' : 'Not Issued'),
    },
    {
      Header: 'RFQ Last Note',
      accessor: 'note.comment',
    },
  ]
  return (
    <div className="p-1 w-full">
      <CustomTable
        data={data}
        rows={3}
        fetching={fetching}
        fetch={fetch}
        tableMinHeight={{ minHeight: '60px' }}
        columns={columns}
        //filterable={false}
      />
    </div>
  )
}
